<template>
  <div class="fooddetails">

      <v-card  class="pb-80 event-details" elevation=0 >
              <v-system-bar
                  flat
                  color="transparent"
                  fixed
                  height="40"
                  class="pt-3">




                  <v-btn @click="backtomenu" fab small color="primary" >
                      <v-icon class="white--text ">mdi-arrow-left</v-icon>
                  </v-btn>

              </v-system-bar>
          <v-card-title class="pa-0 ">



                  <v-img  :src="fooditem.fimage" aspect-ratio="1" class="lighten-2 " max-height="150">

                      <v-row class="fill-height align-start pt-81" style="background:rgba(255,255,255, 0.4);">
                          <v-col cols="12" md="12" sm="12" class="  pl-30">


                              <div class="title">{{fooditem.title}}</div>
                              <span class="subtitle">{{fooditem.subtitle}}</span>


                          </v-col>

                      </v-row>

                  </v-img>


              </v-card-title>
              <v-card-text class="mb-auto">
                <v-row>
                  <!-- <v-col cols="12" class="pb-0">
                    <h2 class="title">Description</h2>
                  </v-col> -->
                  <v-col cols="12" v-html="fooditem.description"></v-col>
                </v-row>
                <v-row v-if="fooditem.meats.length+fooditem.poultrys.length>0">
                  <v-col cols="12" class="pb-0">
                    <p class="title">This Dish Contains The Following Items TEST </p>
                  </v-col>
                  <v-col cols="3" v-for="(meat, index) in fooditem.meats" :key="'m'+index" class="text-center">
                      <img :src="meat.image"  width="32"/><br>{{meat.name}}
                  </v-col>
                  <v-col cols="3" v-for="(poultry, index) in fooditem.poultrys" :key="'m'+index" class="text-center">
                      <img :src="poultry.image"  width="32"/><br>{{poultry.name}}
                  </v-col>
                </v-row>
                <v-row v-if="fooditem.allergens.length>0">
                  <v-col cols="12" class="pb-0">
                    <h2 class="title">Allergens</h2>
                  </v-col>
                  <v-col cols="3" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" class="text-center">
                      <img :src="allergen.image"  width="32"/><br>{{allergen.name}}
                  </v-col>

                </v-row>
                <v-row align="center" v-if="fooditem.chillispice>0">
                  <v-col cols="3"><h2 class="title">Spicy</h2></v-col>
                  <v-col cols="9"><span v-for="n in 5" :key="n" class="pl-1 pr-1">
                      <v-icon :color="n<=fooditem.chillispice?'red':''" >mdi-chili-mild</v-icon>
                    </span></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <h2 class="title">Add to your shortlist...</h2>
                  </v-col>
                  <v-col cols="12" >
                    <v-row v-for="(course, index) in fooditem.courses" :key="'c'+index" align="center">
                      <v-col cols="4">{{course.coursename}}</v-col>
                      <v-col cols="5"><v-text-field @change="setitemtotal(course.courseid)" @keyup="setitemtotal(course.courseid)" @input="setitemtotal(course.courseid)" value="0" :name="'course['+course.courseid+']'" @click:append-outer="addqty(course.courseid)" :id="'course-'+course.courseid"
              @click:prepend="subtractqty(course.courseid)" min="0" type="number" :data-price="course.price" label="Qantity" prepend-icon="mdi-minus-circle-outline" append-outer-icon="mdi-plus-circle-outline"></v-text-field></v-col>
                      <v-col cols="3"><span class="mr-1" :id="'cp-'+course.courseid">{{course.price.toFixed(2)}}</span> <i :class="'fa '+business.currency.icon"></i></v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" >
                  <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" >
                  <v-row>
                    <v-col cols="6"><strong>Total</strong></v-col>
                    <v-col cols="6" class="text-right"><strong class="mr-1" id="tp-total">0.00</strong> <i :class="'fa '+business.currency.icon"></i></v-col>
                  </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6"><v-btn color="primary" @click="backtomenu" block>< Back</v-btn></v-col>
                      <v-col cols="6"><v-btn color="primary" @click="addtoorder" block>Add</v-btn></v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-card-text>
      </v-card>
  </div>
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';


    export default {
        props:['fooditem','business'],
        data: () =>
        ({
          itemtotal:0,
          currentorder:[],
          fooditemid:0,
          courseid:0,
        }),
        created(){
          console.log('itemdetail');
          if(localStorage.getItem('order-'+this.business.id)){
            this.currentorder=JSON.parse(localStorage.getItem('order-'+this.business.id));
          }else{
            localStorage.setItem('order-'+this.business.id,JSON.stringify({'items':[]}));
            this.currentorder=JSON.parse(localStorage.getItem('order-'+this.business.id));
          }

          if (this.$route.params.fooditemid) 
          {
            this.fooditemid = this.$route.params.fooditemid;
          }
           if (this.$route.params.courseid) 
          {
            this.courseid = this.$route.params.courseid;
          }

          this.$http
            .get(this.$apidomain+"itemviewupdate/"+this.fooditemid)
            .then(res => {
            
            })
            .catch(err => {
            console.log(err.response);
          });

        },

        watch:{
            fooditem:function(value)
            {
                return value;
            },

        },
        methods:
        {

          addqty(courseid){
            document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)+1;
            //console.log(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value));
            this.setitemtotal(courseid);
          },

        subtractqty(courseid){
            if(parseInt(document.getElementById('course-'+courseid).value)>0){
              document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)-1;

               // this.itemtotal=(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value)).toFixed(2) ;
              this.setitemtotal(courseid);
            }
            },
            setitemtotal(courseid){
              let total=0;
              this.fooditem.courses.forEach(function(course){
                let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
                let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
                let itemtotal=itemprice*itemqty;

                total=total+itemtotal;
              });
              document.getElementById('tp-total').innerHTML=total.toFixed(2);
            },
            addtoorder()
            {
              let th=this;
              let qty=0;
              th.fooditem.courses.forEach(function(course)
              {
                let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
                qty=qty+itemqty;
                let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
                let itemtotal=itemprice*itemqty;
                if(itemtotal>0){
                th.currentorder.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                }

              })
              localStorage.setItem('order-'+th.business.id,JSON.stringify(th.currentorder));


              this.$http
              .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+qty+'/plus')
              .then(res => {
              
               })
              .catch(err => {
                console.log(err.response);
              });



              this.$router.push({'name':'food'});
            },
            backtomenu(){
              this.$router.push({'name':'food'});
            }
          }


        }

</script>

<style>

.fooddetails .title
    {
        font-size:14px !important;
        line-height: 13px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(233, 17, 17);
        text-transform:uppercase;        
    }
    
    .fooddetails .subtitle{
        padding-top: 10px;
        color: rgb(28, 211, 52);
        font-size:14px;
		font-weight: 400;
        text-transform:capitalize;
        line-height: 12px;
        padding-left: 12px;
        
    }
              
    .fooddetails .description{
        max-block-size: 80%;
        color: rgb(191, 204, 15);
        padding-right: 25px !important;
        padding-top: 5px;
        padding-bottom: 10px;
        padding-left: 0px;
        font-size:10px;
        font-weight: 300;
        line-height:1;
        text-align: justify;
        /* max-height: 100px; */
    
    }







</style>